import React from "react";
import { Dialog, DialogContent, Stack } from "@mui/material";
import MDButton from "components/MDButton";

const ForceCheckout = ({ open, close, guestdetails, editForceCheckout }) => {
  const opensForceCheckout = () => {
    editForceCheckout();
    close();
  };

  return (
    <div>
      <Dialog
        style={{ zIndex: 1800 }}
        open={open}
        keepMounted
        onClose={close}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <div style={{ width: "90%", height:200}}>
          <DialogContent>
            <strong>
              The Guest you are Trying to Checkout is Having an Outstanding Due
              Amount of
            </strong>
            {guestdetails.dueAmount === undefined ?(<></>):( <h4>₹{guestdetails.dueAmount.toFixed(0)}/-</h4>) }
           
          </DialogContent>
          <Stack
            spacing={2}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <MDButton
              size="small"
              variant="contained"
              color="info"
              width="5%"
              onClick={close}
            >
              CancelCheckout
            </MDButton>
            <MDButton
              size="small"
              variant="contained"
              color="info"
              onClick={opensForceCheckout}
            >
              ForceCheckout
            </MDButton>
          </Stack>
        </div>
      </Dialog>
    </div>
  );
};

export default ForceCheckout;
